<header class="flex flex-col gap-3" *ngIf="dataSource && !prevPageLoading">

    <div class="flex items-center gap-2">
        <h1 class="text-2xl !font-extrabold text-black" role="title">{{ params['typeName'] ? 'واحد های اقامتی نوع ' +
            params?.['typeName'] : dataSource!.Title }}</h1>

        <div class="vertical-divider"></div>

        <span class="text-muted text-sm">{{ dataSource!.CountHotel }} واحد اقامتی</span>

    </div>

    <p class="text-sm text-muted"></p>

</header>

<ng-container *ngIf="prevPageLoading">
    <div class="flex items-center gap-3 mb-2 mt-2">
        <iho-skeleton height="2rem" width="10rem" />
        <div class="vertical-divider"></div>
        <iho-skeleton height="1.5rem" width="10rem" />
    </div>
</ng-container>